import policyLibrary from './policyLibrary'
import policyLibraryManagement from './policyLibraryManagement'

export default [...policyLibrary, ...policyLibraryManagement]
